import { registerPlugin } from '@capacitor/core';

export interface LocatorOptions {
  walkRate: number,
  walkDescription: string,
  walkIsAllowFreeMode: boolean
}

export interface LocatorRunning {
  result: boolean;
}

export interface LocatorPlugin {
  requestPermissions(): Promise<void>;

  requestPermissionsIfNeededAndStartService(opts: LocatorOptions): Promise<void>;

  startService(): Promise<void>;

  isServiceRunning(): Promise<LocatorRunning>;

  stopService(): Promise<void>;
}

const Locator: LocatorPlugin = registerPlugin<LocatorPlugin>('Locator');

export default Locator;
